/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimWidget
 */
export interface ClaimWidget {
    /**
     * 
     * @type {number}
     * @memberof ClaimWidget
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimWidget
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimWidget
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimWidget
     */
    publicKey: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimWidget
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClaimWidget
     */
    allowedOrigins: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ClaimWidget
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof ClaimWidget
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimWidget
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ClaimWidget interface.
 */
export function instanceOfClaimWidget(value: object): value is ClaimWidget {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('publicKey' in value) || value['publicKey'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('allowedOrigins' in value) || value['allowedOrigins'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ClaimWidgetFromJSON(json: any): ClaimWidget {
    return ClaimWidgetFromJSONTyped(json, false);
}

export function ClaimWidgetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimWidget {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'publicKey': json['publicKey'],
        'isActive': json['isActive'],
        'allowedOrigins': json['allowedOrigins'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ClaimWidgetToJSON(json: any): ClaimWidget {
    return ClaimWidgetToJSONTyped(json, false);
}

export function ClaimWidgetToJSONTyped(value?: ClaimWidget | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'name': value['name'],
        'publicKey': value['publicKey'],
        'isActive': value['isActive'],
        'allowedOrigins': value['allowedOrigins'],
        'createdBy': value['createdBy'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

